export enum TSBemerkungScope {
    SCHADENFALL = <any> 'SCHADENFALL',
    AUFWAENDE = <any> 'AUFWAENDE',
    BEMERKUNG_VIEW = <any> 'BEMERKUNG_VIEW',
    SYSTEM = <any> 'SYSTEM'
}
export function getTSBemerkungScopeValues(): Array<TSBemerkungScope> {
    return [
        TSBemerkungScope.SCHADENFALL,
        TSBemerkungScope.AUFWAENDE,
        TSBemerkungScope.SYSTEM,
        TSBemerkungScope.BEMERKUNG_VIEW,
    ];
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSBemerkungScope.ts